import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../../services/authentication.service';
import { Router } from '@angular/router';
import { ALERT_DIALOG_TYPE, AlertDialogPayload } from '../../../library/lib/interfaces/alert-dialog-payload.interface';
import { LibraryService } from '../../../library/lib/services/library.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.less'
})
export class HeaderComponent implements OnInit {

  @Input() headerFooterCMSData: any;
  currentUser: any;
  isLogin: boolean = false;
  sponsorLogo: any;
  notificationIcon: any;
  settingsIcon: any;
  getGenericSettings: any;
  showTooltip: boolean = false;
  logoutIcon='assets/images/icons/logout_icon.png';
  constructor(
    private authenticationService: AuthenticationService, 
    private router:Router,
    private libraryService: LibraryService,
  ) {
  }
  ngOnInit(): void {
    this.getGenericSettings = JSON.parse(localStorage.getItem('portalGenericSettings') || '{}');
    this.sponsorLogo = 'https:' +  this.headerFooterCMSData?.sponsorLogo?.fields.file.url;
    this.notificationIcon = 'https:' +  this.headerFooterCMSData?.notificationIcon?.fields.file.url;
    this.settingsIcon = 'https:' +  this.headerFooterCMSData?.settingsIcon?.fields.file.url;
    this.authenticationService.currentUser.subscribe(data => {
      this.currentUser = data;
      if(this.currentUser && (this.currentUser.token)) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    });
  }
  get usersInitial() {
    const value = localStorage.getItem('usersInitial');
    return value !== null ? JSON.parse(value) : '';
  } 
  logout() {
    const config: AlertDialogPayload = {
      icon: 'assets/images/icons/warning.png',
      title: 'Warning',
      body: [`Are you sure you want to Logout?`],
      actions: [
        {
          displayText: 'NO',
          key: 'no',
          type: 'default',
          width: 155,
          height: 48,
        },
        {
          displayText: 'YES',
          key: 'yes',
          type: 'primary',
          width: 155,
          height: 48,
        }
      ],
      type: ALERT_DIALOG_TYPE.DEFAULT
    };
    this.libraryService.openAlertDialog(config).afterClosed().subscribe({
      next: (res: any) => {
        if (res === 'yes') {
          this.authenticationService.logoutUser();
        }
      },
    });
  }
  toggleTooltip(){
  this.showTooltip=!this.showTooltip;
  }
  routeToLogin() {
    if(this.isLogin) {
      this.router.navigate(['/offers']);
    } else {
      this.router.navigate(['/home']);
    }
  }

}
